import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export type AlertTone = 'info' | 'success' | 'warning' | 'error'

const TONES: Record<AlertTone, string> = {
  info: 'border-sky-400/30 bg-sky-400/10 text-sky-100',
  success: 'border-green-400/30 bg-green-400/10 text-green-100',
  warning: 'border-amber-400/30 bg-amber-400/10 text-amber-100',
  error: 'border-red-400/35 bg-red-400/10 text-red-100',
}

export function Alert({
  tone = 'info',
  title,
  className,
  children,
}: {
  tone?: AlertTone
  title?: string
  className?: string
  children?: ReactNode
}) {
  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      className={cn('rounded-xl border px-4 py-3 text-sm', TONES[tone], className)}
    >
      {title && <p className="font-semibold">{title}</p>}
      {children && <div className={cn(title && 'mt-1')}>{children}</div>}
    </div>
  )
}
